export const environment = {
    production: true,
    firebase: {
        apiKey: 'AIzaSyDh6Udn5wLIQfxFruIOZQwRlFyJisGuDks',
        authDomain: 'sise-uat-4d25e.firebaseapp.com',
        projectId: 'sise-uat-4d25e',
        storageBucket: 'sise-uat-4d25e.firebasestorage.app',
        messagingSenderId: '492215337810',
        appId: '1:492215337810:web:c52d78fc62ed20edec308b',
        measurementId: 'G-K9V0YHTPVW'
    },
    logoHotel: 'https://sise-util.s3.amazonaws.com/role/hotel.png',
    backendUrl: 'https://backend.uat.sise.tax',
    apiICSOE: 'https://icsoe.taxsat.com',
    versionSISE: 'App v2.0.0',
    webhookDiscord: 'https://discord.com/api/webhooks/1415817280062885969/jNvHdTpndZ_N8GhcB0xoL6469dee7QBOXTKVV4tO9JUyXycFlXhMyypkEPM3TLf51RCc',
    webhookDiscordHotel: 'https://discord.com/api/webhooks/1415816943528837241/HTscZ0dvOx8gyfp54nQs4pq4jGrjNDZTzCVEuNrZ73NPThitaIscDroIx7IuAXdLp-S9',
    webhookDiscordSemiMaster: 'https://discord.com/api/webhooks/1415817565783064577/cW5RteRgUu3JQmHCnezlfTsFgPRC2_iGdaxMvcbFCFaeO2khzwetXPBRLKl4IDpMotfS',
    webhookDiscordDocument: 'https://discord.com/api/webhooks/1415817396790497421/LOqjU79no-chFOqvEdB_ay4XJqvGBkhede69-TIeO6XLEZI6USKhw3QJG0XR3lAUMMT0',
    webhookDiscordError: 'https://discord.com/api/webhooks/1415817498368147540/aCZKxogFJLSAyk1xPQdS8aDvaVGJw2qdb-jKjFkFofmq9bgREYQucRN43RegZmHd83Q7',
    webhookDiscordDownloads: 'https://discord.com/api/webhooks/1415817184160120923/w3_-Ts2w2SLTCk_xm_eR2T9k5dRixSyml6QmJBxqobNXKMUUCeo7lMeChut8rriFqbQY',
    webhookDiscordUtil: 'https://discord.com/api/webhooks/1415817648234565799/-xnQ311-S8MkoB2ehLnTv47M_I8XLt7f3aWFIN5tnB-CZOGTPSjbyzMn2cK_MXRldusI',
    webhookDiscordUPolizasFianzas: 'https://discord.com/api/webhooks/1516170326151790632/_B4SHKfHwSCSOwo3pSzniiU_W5aaqin_khuzJ9y5aR30pKNmJ2hpH-jSQpIWIS70FN7G',
    apiKeyEDOFAC: '99ae93da64b55b4fa40ac70623bca03300d1de86eaa98a6a76bb488745d2ed46'
};
